/*
 * Common utility methods
 */

// eslint-disable-next-line no-var
var Util = function() {

  this.syncAndRemoveCheckbox = function(checkbox, checkboxHidden) {
    if (checkbox && checkboxHidden) {
      checkboxHidden.attr('value', checkbox.is(':checked') ? 'yes' : 'no');
      // push just hidden value and don't rely on checkbox input element
      checkbox.attr("disabled", true);
    }
  };

  this.syncAndRemoveCheckboxNumeric = function(checkbox, checkboxHidden) {
    if (checkbox && checkboxHidden) {
      checkboxHidden.attr('value', checkbox.is(':checked') ? '1' : '0');
      // push just hidden value and don't rely on checkbox input element
      checkbox.attr("disabled", true);
    }
  };

  this.syncAndRemoveCheckboxMarketingOptIn = function(marketingOptIn, marketingOptInHidden, marketingOptInPartnerDisclosureHidden) {
    if (marketingOptIn) {
      if (marketingOptInHidden) {
        marketingOptInHidden.attr('value', marketingOptIn.is(':checked') ? '1' : '0');
        marketingOptIn.attr("disabled", true);
      }
      if (marketingOptInPartnerDisclosureHidden){
        marketingOptInPartnerDisclosureHidden.attr('value', marketingOptIn.is(':checked') ? '1' : '0');
      }
    }
  };

  this.stringContains = function(string, substring){
    return string.indexOf(substring) > -1;
  };

  this.containsUsernameUnsupportedCodePoint = function(str) {
    for (let i = 0, n = str.length; i < n; i++) {
      if (str.charCodeAt( i ) <=32 || str.charCodeAt( i ) >= 127) { return true; }
    }
    return false;
  }

  this.formFieldRequiredMarkRemove = function(fieldName){
    const field = $("label[for = "+fieldName+"]");
    // eslint-disable-next-line no-useless-escape
    field.html(field.html().replace(" \*", ""));
  };

  this.formFieldRequiredMarkAdd = function(fieldName){
    const field = $("label[for = "+fieldName+"]");
    // eslint-disable-next-line no-useless-escape
    if(! util.stringContains(field.text(), "\*"))
      field.text(field.text() + " *");
  };

  this.getCookie = function(cname) {
    const name = cname + "=";
    const ca = document.cookie.split(';');
    for(let i=0; i<ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1);
      if (c.indexOf(name) === 0) return c.substring(name.length,c.length);
    }
    return "";
  };

  this.deleteCookie = function(name) {
    document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  this.getUsernameFromSession = function() {
    return sessionStorage.getItem("input")
  }

  this.setUsernameToSession = function(username) {
    sessionStorage.setItem("input", username);
  }
  this.adaptProgressiveProfileLevel = function(){
    // Download UI texts handling
    // eslint-disable-next-line no-undef
    if(rhd.config.user_profile_level === "download"){
      $('.download-hide').remove();
      $('.download-show').show();
    } else {
      $('.download-show').remove();
    }
  };


  const modalActiveClass = "modal-active";
  this.toggleModal = function(id) {
    const modalWindow = $("#"+id);
    const isModalActive = modalWindow.hasClass(modalActiveClass);
    modalWindow.toggleClass("modal-active");
    if (isModalActive) {
      const popupMask = $("#PopupMask");
      if (popupMask != null)  {
        popupMask.remove();
      }
      modalWindow.css( "z-index" , $("#"+id).data('saveZindex') );
    } else {
      $("body").prepend("<div id='PopupMask' style='position:fixed;width:100%;height:100%;z-index:10;background-color:gray;'></div>");
      $("#PopupMask").css('opacity', 0.7);
      modalWindow.data('saveZindex', modalWindow.css( "z-index"));
      modalWindow.css( "z-index" , 11);
    }
  };

  this.clearTimeoutError = function (justPath) {
    if(!justPath){
      const formAlert = document.getElementById("rh-login-form-alert-username");
      if(!formAlert.classList.contains('pf-u-display-none')){
        formAlert.classList.add('pf-u-display-none');
      }
    }
    
    // clear extra parameter from the url string to make sure refresh doesnt 
    // re-trigger the error. 
    const path = window.location.pathname;
    const search = window.location.search.slice(0,window.location.search.indexOf("&timeout=1"));
    window.history.replaceState({}, document.title, path+search);
  }
  
  /**
    Used at the username-verification stage to check if the page was refreshed 
    in the event of a timeout error.
  */
  this.checkForTimeout = function () {
    const { timeout } = qs;
    if(timeout) {
      const formAlert = document.getElementById("rh-login-form-alert-username");
      if(formAlert.classList.contains('pf-u-display-none')){
        formAlert.classList.remove('pf-u-display-none');
      }
      this.clearTimeoutError(true);
    }
  }



  this.fillUsernameFieldFromParam = function(){
    const {un} = qs;
    if(un){
      // set the username value;
      const usernameDomEl = document.getElementById('username');
      usernameDomEl.value = un;
      
      // since the username is specified disable the input from being edited
      usernameDomEl.setAttribute("readonly",true);
      usernameDomEl.classList.add("disabledUsernameInput");
    }
  };
  
  this.checkAutoFillUsername = function(){
    qs.un ? this.fillUsernameFieldFromParam() : this.pullUserFromLocal();
  }
  
  /*
  * If a username exists in localstorage, then automatically fill in the 
  * username credentials. 
  */
  this.pullUserFromLocal = function(){
    // check for user session storage
    const existingUserName = sessionStorage.getItem("input");
    if(existingUserName && existingUserName.length > 0){
      const usernameDomEl = document.getElementById('username');
      usernameDomEl.value = existingUserName;
      
      // since the username is specified disable the input from being edited
      usernameDomEl.setAttribute("readonly",true);
      usernameDomEl.classList.add("disabledUsernameInput");
    }
  }

  /*
   * parse query string and place it's elements into qs map
   */
  const qs = (function(a) {
    if (a === "") return {};
    const b = {};
    for (let i = 0; i < a.length; ++i)
    {
      const p=a[i].split('=', 2);
      if (p.length === 1)
        b[p[0]] = "";
      else
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, " "));
    }
    return b;
  })(window.location.search.substr(1).split('&'));

  /* Updates given URI by specified parameter and value. Returns updated URI */
  this.updateQueryStringParameter = function (uri, key, value) {
    const re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    const separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    
    return uri + separator + key + "=" + value;
    
  }

  this.hidePassword = function (button, icon, input) {
    icon.attr('class', 'fas fa-eye');
    input.attr('type', 'password');
    button.attr({
      'aria-label': 'Show Password',
      title: 'Show Password',
      'aria-pressed': 'false'
    });
  }

  this.showPassword = function (button, icon, input) {
    icon.attr('class', 'fas fa-eye-slash');
    input.attr('type', 'text');
    button.attr({
      'aria-label': 'Hide Password',
      'title': 'Hide Password',
      'aria-pressed': 'true'
    });
  }
  // Show password
  this.addPasswordToggle = function() {
    $('#rh-pw-password-toggle').on('click tap dbltap longtap', (e) => {
      e.preventDefault();
      const toggleButton = $('#rh-pw-password-toggle');
      const toggleButtonIcon = toggleButton.find('svg');
      const passwordInput = $('#password');
      // Check the current state by looking at the input type
      if (passwordInput.attr('type') === 'password') {
        util.showPassword(toggleButton, toggleButtonIcon, passwordInput);
      } else {
        util.hidePassword(toggleButton, toggleButtonIcon, passwordInput);
      }
    });
  }
  this.isPasswordVerificationFormValid = function() {
    const username = $('#username');
    const password = $('#password');
    if (username.val() === '' || password.val() === '') {
      return false;
    }
    return true;
  }
  
  this.hideFormErrorMessage = function() {
    $('#rh-login-form-alert').addClass('pf-u-display-none');
  }

  this.showFieldErrorMessage = function (input, span, text) {
    input.attr('aria-invalid', 'true');
    span.text(text);
    span.closest('.pf-c-form__helper-text').removeClass('hide-error-text');
  }

  this.hideFieldErrorMessage = function (input, span) {
    input.attr('aria-invalid', 'false');
    span.text('');
    span.closest('.pf-c-form__helper-text').addClass('hide-error-text');
  }


  this.showFormErrorMessage = function(title, body) {
      
    const rootAlert = document.getElementById("rh-login-form-alert");
    const errorTitle = document.getElementById('rh-login-form-error-title');

    // verify that a value is to be set
    if (rootAlert && title && errorTitle) {
          
      // set the title value
      const titleText = document.createTextNode(title);
      // if the user already caught this error and triggers again... remove old text
      errorTitle.firstChild && errorTitle.removeChild(errorTitle.firstChild);
      errorTitle.appendChild(titleText);
          
          
      // handle the body of the error
      const errorBody = document.getElementById("rh-login-form-error-body");
      if(errorBody){
        // set the body value if it exists.
        const bodyTextSpan = document.createElement("span");
        // eslint-disable-next-line no-var
        var bodyText = document.createTextNode(body || '');
        bodyTextSpan.appendChild(bodyText);
              
        // remove all child nodes if they already exist (user continues to mash next)
        while(errorBody.firstChild){
          errorBody.removeChild(errorBody.firstChild);
        }
        errorBody.appendChild(bodyTextSpan);
        errorBody.appendChild(document.createElement("br"))
      }
          
      // now make sure the error form is visible 
      if(rootAlert.classList.contains('pf-u-display-none')){
        // classList is 'partially supported in IE 10 and 11 but this should work fine
        rootAlert.classList.remove('pf-u-display-none');
      }
    }
    else{
      // eslint-disable-next-line no-console
      console.error("Form error message was triggered but failed to generate");
    }
  }
};
// eslint-disable-next-line no-var
var util = new Util();